export const en = {
  "auth.signIn": "Sign in",
  "auth.signOut": "Sign out",
  "auth.label": "Members",
  "auth.title": "Sign in to see the cars",
  "auth.sub": "Live inventory from Korea and Japan, with the landed price in your country. Enter your email and we send you a link — no password to invent or remember.",
  "auth.send": "Send me the link",
  "auth.sending": "Sending…",
  "auth.why": "We use your address to send the link and to answer your enquiries. Nothing else, and never to anyone else.",
  "auth.sentLabel": "Check your email",
  "auth.sentTitle": "The link is on its way",
  "auth.sentBody": "We sent a sign-in link to {email}. Open it on this device and you are in.",
  "auth.sentSpam": "It should arrive within a minute. If it does not, look in the spam folder — and check the address you typed.",
  "auth.useAnother": "Use a different address",
  "auth.alreadyIn": "You are signed in",
  "auth.err.invalid_email": "That does not look like an email address.",
  "auth.err.too_many": "Too many links requested. Wait a few minutes and try again.",
  "auth.err.mail_failed": "We could not send the email just now. Try again in a moment.",
  "auth.err.link_expired": "That link has expired or was already used. Here is a fresh one.",
  "nav.stock": "Stock",
  "nav.auctions": "Japan auctions",
  "nav.calculator": "Import calculator",
  "nav.how": "How it works",
  "nav.contact": "Contact",

  "common.from": "from",
  "common.to": "to",
  "common.any": "Any",
  "common.all": "All",
  "common.loading": "Loading…",
  "common.showMore": "Show more",
  "common.showLess": "Show less",
  "common.reset": "Reset",
  "common.close": "Close",
  "common.back": "Back",
  "common.km": "km",
  "common.year": "Year",
  "common.results": "{n} cars",
  "common.noResults": "No cars match these filters",
  "common.noResultsBody": "Try widening the price or year range, or clear a filter.",
  "common.estimate": "Estimate",
  "common.optional": "optional",
  "common.required": "required",
  "common.error": "Something went wrong. Please try again.",
  "common.retry": "Retry",

  "home.eyebrow": "Korea · Japan → Europe",
  "home.title": "The cars Europe never got.",
  "home.sub": "Performance and luxury cars sourced in Korea and Japan, landed at your door in {country} — duty, VAT and homologation included in every price you see.",
  "home.cta": "Browse stock",
  "home.cta2": "Estimate an import",
  "home.stat.cars": "cars listed",
  "home.stat.makes": "makes",
  "home.stat.markets": "source markets",
  "home.why.title": "Why Korea and Japan",
  "home.why.kr.title": "Korea is left-hand drive",
  "home.why.kr.body": "Koreans drive on the right, so every Korean car is LHD — usable in France, Switzerland, Germany and Luxembourg with no conversion. It is a large, wealthy, hard-driven market that European buyers never see.",
  "home.why.jp.title": "Japan keeps them immaculate",
  "home.why.jp.body": "Japanese cars are famously low-mileage and carefully kept, and the graded auction system makes condition legible before you bid. We only list left-hand-drive cars — European exotics sold new in Japan.",
  "home.why.price.title": "One number, nothing hidden",
  "home.why.price.body": "Every car shows what it costs to put on your driveway: purchase, export, freight, duty, VAT, homologation, registration. Not a teaser price with surprises at the port.",
  "home.featured": "In stock now",
  "home.featuredAll": "See all stock",

  "stock.title": "Stock",
  "stock.sub": "Live inventory from Korea and Japan. Prices shown are estimated landed cost in {country}.",
  "stock.filters": "Filters",
  "stock.sort": "Sort",
  "stock.sort.newest": "Newest first",
  "stock.sort.price_asc": "Landed price: low to high",
  "stock.sort.price_desc": "Landed price: high to low",
  "stock.sort.year_desc": "Year: newest",
  "stock.sort.mileage_asc": "Mileage: lowest",
  "stock.search": "Search make, model…",
  "stock.f.make": "Make",
  "stock.f.model": "Model",
  "stock.f.source": "Market",
  "stock.f.price": "Landed price",
  "stock.f.year": "Year",
  "stock.f.mileage": "Max mileage",
  "stock.f.fuel": "Fuel",
  "stock.f.body": "Body",
  "stock.f.transmission": "Gearbox",
  "stock.f.steering": "Steering",
  "stock.f.photos": "With photos only",
  "stock.f.search": "Search",
  "stock.f.noMatch": "No match",
  "stock.steering.LHD": "Left-hand drive",
  "stock.steering.RHD": "Right-hand drive",
  "stock.steering.any": "Any",
  "stock.clearAll": "Clear all",

  "car.landedIn": "Landed in {country}",
  "car.estimateNote": "Estimated, all-in. Range reflects items we quote per car.",
  "car.listedAt": "Listed in {market} at",
  "car.compare": "Compare countries",
  "car.compareNote": "Same car, four destinations. Tax and homologation differ sharply.",
  "car.cheapest": "Cheapest",
  "car.breakdown": "What makes up this price",
  "car.leadTime": "Estimated lead time",
  "car.leadTimeDays": "{n} days",
  "car.enquire": "Enquire about this car",
  "car.enquireSub": "We confirm the exact figure, inspect the car and handle everything to your door.",
  "car.specs": "Specification",
  "car.spec.year": "Year",
  "car.spec.mileage": "Mileage",
  "car.spec.fuel": "Fuel",
  "car.spec.transmission": "Gearbox",
  "car.spec.engine": "Engine",
  "car.spec.body": "Body",
  "car.spec.colour": "Colour",
  "car.spec.steering": "Steering",
  "car.spec.seats": "Seats",
  "car.spec.location": "Location",
  "car.spec.seller": "Seller",
  "car.advisory": "Possible additional work",
  "car.advisoryNote": "Not included in the price above. Almost none of this applies to a given car — whatever the inspection finds is quoted separately before you commit.",
  "car.advisoryUpTo": "up to {amount} if all of it were needed",
  "car.priceOnRequest": "Price on request",
  "car.priceOnRequestBody": "This car is listed without a public price. We will obtain it and quote the full landed cost.",
  "car.daysOnMarket": "On the market {n} days",
  "car.daysOnMarketHelp": "How long this car has been advertised in its home market. A car that has sat for months is usually negotiable.",
  "car.demoLot": "Sample lot",
  "car.demoLotNote": "This is a demonstration lot, not a car you can buy. Live auction inventory is not connected yet — the figures show how a real lot would be quoted.",

  // fuel
  "spec.fuel.petrol": "Petrol",
  "spec.fuel.diesel": "Diesel",
  "spec.fuel.electric": "Electric",
  "spec.fuel.hybrid": "Hybrid",
  "spec.fuel.petrol-hybrid": "Petrol hybrid",
  "spec.fuel.diesel-hybrid": "Diesel hybrid",
  "spec.fuel.petrol-lpg": "Petrol / LPG",
  "spec.fuel.lpg": "LPG",
  "spec.fuel.hydrogen": "Hydrogen",

  // transmission
  "spec.transmission.automatic": "Automatic",
  "spec.transmission.manual": "Manual",
  "spec.transmission.semi-automatic": "Semi-automatic",
  "spec.transmission.cvt": "CVT",
  "spec.transmission.dct": "DCT",

  // body
  "spec.body.suv": "SUV",
  "spec.body.sports-car": "Sports car",
  "spec.body.saloon": "Saloon",
  "spec.body.coupe": "Coupé",
  "spec.body.convertible": "Convertible",
  "spec.body.estate": "Estate",
  "spec.body.hatchback": "Hatchback",
  "spec.body.mpv": "MPV",
  "spec.body.van": "Van",
  "spec.body.truck": "Truck",
  "spec.body.city-car": "City car",
  "spec.body.small-car": "Small car",
  "spec.body.compact": "Compact",
  "spec.body.mid-size": "Mid-size",
  "spec.body.full-size": "Full-size",

  // seller
  "spec.seller.dealer": "Dealer",
  "spec.seller.private": "Private seller",
  "spec.seller.auction": "Auction",
  "car.similar": "Similar cars",
  "car.assumptions": "What we assumed",
  "car.assumptionsNote": "These fields are not published by the source. We confirm each before issuing a firm quote — they can move the total.",
  "car.required": "Required",
  "car.quotedPerCar": "Quoted per car",
  "car.import.hard": "Hard to register in {country}",
  "car.import.hardTitle": "Difficult to register in {country}",
  "car.import.hardBody": "This one is importable, but the approval is not routine and we price it case by case. Ask us before you commit to anything.",
  "car.import.noTitle": "Not importable to {country}",
  "car.import.noBody": "This marque cannot be registered in {country} as a private import. The car is still shown because you followed a link to it — switch your country above and it may well be available.",
  "car.import.lightsTitle": "Japanese car — headlights must be changed",
  "car.import.lightsBody": "Japan drives on the left, so its headlights are aimed for left-hand traffic and every car coming out of it needs them replaced. Marque makes no difference. We quote the work per car.",
  "car.gone": "No longer available",
  "car.goneBody": "This car has left the market. Tell us what you were looking for and we will find another.",
  "car.freight": "Shipping method",
  "car.freight.roro": "RoRo (cheapest)",
  "car.freight.container_shared": "Shared container",
  "car.freight.container_exclusive": "Exclusive container",
  "car.coc": "Manufacturer can supply an EU certificate of conformity",
  "car.cocHelp": "Many European cars exported new to Korea or Japan can still get a COC. It replaces individual approval and cuts homologation cost sharply.",
  "car.confidence.placeholder": "Indicative",
  "car.confidence.placeholderHelp": "Indicative — figures still being verified",
  "car.confidence.estimate": "Estimate",
  "car.confidence.estimateHelp": "Estimate — most figures verified",
  "car.confidence.researched": "Researched",
  "car.confidence.researchedHelp": "Researched figures",

  "auctions.title": "Japanese auctions",
  "auctions.sub": "Around 30,000 cars cross the block in Japan every week. We bid on your behalf, with the auction sheet read and translated first.",
  "auctions.upcoming": "Upcoming lots",
  "auctions.resultsTitle": "What these cars actually sell for",
  "auctions.resultsSub": "Hammer prices from recent sales in Japan — {n} results across {models} models, {from} to {to}. Shown for the marques we import.",
  "auctions.resultsModel": "Model",
  "auctions.resultsSales": "Sales",
  "auctions.resultsMedian": "Median hammer",
  "auctions.grades": "Understanding auction grades",
  "auctions.gradesSub": "Every car is inspected and graded by the auction house before sale. The grade is the single most important number on the sheet.",
  "auctions.grade": "Grade",
  "auctions.interior": "Interior",
  "auctions.lot": "Lot",
  "auctions.house": "Auction house",
  "auctions.saleDate": "Sale date",
  "auctions.estimate": "Estimated hammer",
  "auctions.bidCta": "Ask us to bid",
  "auctions.notConfigured": "Live auction data is not connected yet. The lots below are representative examples of what we bid on.",
  "enq.w.gradeMin": "Lowest auction grade",
  "enq.w.gradeMinHelp": "The inspector's verdict on the car. 4 and above is the usual floor for an import.",
  "enq.w.maxHammer": "Maximum hammer price (JPY)",
  "enq.w.maxHammerHelp": "What we must not bid past. Everything after it — export, freight, duty, homologation — we quote before you commit.",
  "auctions.bidTitle": "Have us bid for you",
  "auctions.bidSub": "Tell us the car and the ceiling. We work the halls each week, read and translate the inspection sheet, and come back with the lots worth bidding on and what each one lands at in your country — before anything is bid.",
  "auctions.bidNote": "Around 30,000 cars cross the block every week and a lot is on the screen for minutes. A standing brief is how this is bought.",
  "auctions.samplesTitle": "What a lot looks like priced",
  "market.title": "At Japanese auction",
  "market.headline": "A comparable {what} has hammered at around {amount}, across {n} sales.",
  "market.spread": "Half of them fell between {band}.",
  "market.unsold": "{n} of {total} did not meet reserve.",
  "market.unsold.one": "1 of {total} did not meet reserve.",
  "market.basis": "Hammer price only — before auction fees, export, freight, duty, VAT and homologation. Wholesale, which is why it sits below the landed figure above. Third-party data; we did not attend these sales.",
  "market.period": "Sales from {from} to {to}.",
  "market.scope.model": "{what}, all model years",
  "market.scope.years": "{what} from {from}–{to}",
  "auctions.sheetMarks": "Sheet marks",

  "calc.title": "Import calculator",
  "calc.sub": "Already found a car? Put in the price and we will show you what it costs landed, homologated and plated.",
  "calc.price": "Price in the source market",
  "calc.origin": "Where the car is",
  "calc.destination": "Where you are",
  "calc.weight": "Kerb weight (kg)",
  "calc.co2": "CO₂ (g/km, WLTP)",
  "calc.cc": "Displacement (cc)",
  "calc.year": "Year",
  "calc.compute": "Calculate",
  "calc.co2Help": "France taxes CO₂ steeply — without this figure the estimate cannot include the malus, which can exceed the car's price.",
  "calc.weightHelp": "Drives the French weight malus and Swiss duty.",

  "how.title": "How it works",
  "how.s1.title": "Choose the car",
  "how.s1.body": "Browse live stock from Korea and Japan, or tell us what you want and we hunt for it — including cars that never reach a public listing.",
  "how.s2.title": "We inspect it",
  "how.s2.body": "An independent inspection on the ground before any money moves. For auction lots, we read and translate the auction sheet first.",
  "how.s3.title": "We buy and ship",
  "how.s3.body": "Purchase, export de-registration, inland transport and ocean freight, fully insured, to a European port.",
  "how.s4.title": "Customs and homologation",
  "how.s4.body": "Duty, VAT, the individual approval or COC route for your country, and any conversion work the car needs to be road-legal.",
  "how.s5.title": "Plated and delivered",
  "how.s5.body": "Registered in your name, plated, and delivered to your door, ready to drive.",
  "how.homologation": "Homologation by country",
  "how.homologationSub": "The legal route a car takes to become road-legal differs by country, and it is the part most importers get wrong.",
  "how.route": "Route",
  "how.cost": "Typical cost",
  "how.leadTime": "Lead time",
  "how.noCoc": "Without an EU certificate of conformity",
  "how.withCoc": "With an EU certificate of conformity",
  "how.vat": "Import VAT",
  "how.duty": "Customs duty",

  "enq.title": "Enquire",
  "enq.name": "Name",
  "enq.email": "Email",
  "enq.phone": "Phone",
  "enq.country": "Delivery country",
  "enq.message": "Anything we should know",
  "enq.messagePlaceholder": "Timing, budget, specification, part-exchange…",
  "enq.submit": "Send enquiry",
  "enq.sending": "Sending…",
  "enq.success": "Enquiry received",
  "enq.successBody": "Your reference is {ref}. We will come back to you within one business day with a firm quotation.",
  "enq.error": "We could not send that. Please try again, or email contact@apexcars.ch.",
  "enq.wanted": "Tell us what to find",
  "enq.wantedSub": "Most of what we sell never appears on a public listing. Describe the car and we go looking.",
  "enq.w.make": "Make",
  "enq.w.model": "Model",
  "enq.w.yearFrom": "Year from",
  "enq.w.yearTo": "Year to",
  "enq.w.budget": "Budget (EUR)",
  "enq.w.mileage": "Max mileage (km)",
  "enq.w.colour": "Colour",
  "enq.w.notes": "Specification, options, anything non-negotiable",
  "enq.consent": "We use your details only to answer this enquiry.",

  "footer.tagline": "Driven by the hunt.",
  "footer.rights": "All rights reserved.",
  "footer.disclaimer": "Prices shown are estimates computed from published duty, VAT and homologation rules. They are not an offer. A firm quotation follows inspection and confirmation of the vehicle's documentation.",
  "market.encar": "Korea",
  "market.goonet": "Japan",
  "market.jpauction": "Japan auctions",
  "common.noPhoto": "Photos not available",
  "common.previous": "Previous",
  "common.next": "Next",
  "common.photo": "Photo {n}",
  "common.language": "Language",
  "common.menu": "Menu",
  "common.currency": "Currency",
  "stock.sourcePrice": "Source price in EUR",
  "car.noRepair": "No repair history",
  "car.repair": "Repair history",
  "car.origin": "FTA origin",
  "home.stat.days": "Average time on market",
};
